import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import FeaturedCategories from './components/FeaturedCategories';
import ArticlesGrid from './components/ArticlesGrid';
import AllCategories from './components/AllCategories';
import ArticleIntro from './components/ArticleIntro';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuy.study';

const jsonLdWebsite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'VigorBuy',
  url: siteUrl,
  description: 'Vigorbuy Spreadsheet Resource Center - Product Database & Buying Guides',
};

const jsonLdOrganization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'VigorBuy',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg',
  description: 'Vigorbuy Spreadsheet Resource Center - Product Database & Buying Guides',
};

const jsonLdFAQ = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is Vigorbuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Vigorbuy Spreadsheet is a comprehensive product database and buying guide platform that helps shoppers discover, compare, and purchase products across multiple categories including shoes, clothing, accessories, bags, and more.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does Vigorbuy Spreadsheet work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The Vigorbuy Spreadsheet organizes thousands of products into easy-to-navigate categories. Each listing includes key product details, pricing information, and direct links to purchase.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is Vigorbuy Spreadsheet safe to use?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Vigorbuy Spreadsheet is a safe and reliable resource. All product links direct you to the official Kaspreadsheet platform, which follows standard e-commerce security practices.',
      },
    },
    {
      '@type': 'Question',
      name: 'How often is the spreadsheet updated?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The Vigorbuy Spreadsheet is updated daily to reflect the latest product listings, price changes, and availability.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I compare products using Vigorbuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Absolutely. One of the core benefits of the Vigorbuy Spreadsheet is its comparison capability across products within the same category.',
      },
    },
    {
      '@type': 'Question',
      name: 'Do I need an account to use Vigorbuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No account is required. The Vigorbuy Spreadsheet is freely accessible to everyone.',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdWebsite) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdOrganization) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdFAQ) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <FeaturedCategories />
        <ArticlesGrid />
        <AllCategories />
        <ArticleIntro />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}